package com.iptvplayer.shared.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Double
import kotlin.Long
import kotlin.String

public class SeriesQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    sourceId: String,
    seriesId: Long,
    name: String,
    posterUrl: String?,
    plot: String?,
    castMembers: String?,
    director: String?,
    genre: String?,
    releaseDate: String?,
    rating: Double?,
    groupName: String?,
  ) -> T): Query<T> = Query(1_534_183_030, arrayOf("SeriesEntity"), driver, "Series.sq",
      "selectAll",
      "SELECT SeriesEntity.id, SeriesEntity.sourceId, SeriesEntity.seriesId, SeriesEntity.name, SeriesEntity.posterUrl, SeriesEntity.plot, SeriesEntity.castMembers, SeriesEntity.director, SeriesEntity.genre, SeriesEntity.releaseDate, SeriesEntity.rating, SeriesEntity.groupName FROM SeriesEntity") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getLong(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getString(7),
      cursor.getString(8),
      cursor.getString(9),
      cursor.getDouble(10),
      cursor.getString(11)
    )
  }

  public fun selectAll(): Query<SeriesEntity> = selectAll { id, sourceId, seriesId, name, posterUrl,
      plot, castMembers, director, genre, releaseDate, rating, groupName ->
    SeriesEntity(
      id,
      sourceId,
      seriesId,
      name,
      posterUrl,
      plot,
      castMembers,
      director,
      genre,
      releaseDate,
      rating,
      groupName
    )
  }

  public fun selectGroups(): Query<String> = Query(-2_017_795_873, arrayOf("SeriesEntity"), driver,
      "Series.sq", "selectGroups",
      "SELECT DISTINCT groupName FROM SeriesEntity WHERE groupName IS NOT NULL ORDER BY groupName") {
      cursor ->
    cursor.getString(0)!!
  }

  public fun <T : Any> pageFiltered(
    group: String?,
    query: String?,
    limit: Long,
    offset: Long,
    mapper: (
      id: String,
      sourceId: String,
      seriesId: Long,
      name: String,
      posterUrl: String?,
      plot: String?,
      castMembers: String?,
      director: String?,
      genre: String?,
      releaseDate: String?,
      rating: Double?,
      groupName: String?,
    ) -> T,
  ): Query<T> = PageFilteredQuery(group, query, limit, offset) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getLong(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getString(7),
      cursor.getString(8),
      cursor.getString(9),
      cursor.getDouble(10),
      cursor.getString(11)
    )
  }

  public fun pageFiltered(
    group: String?,
    query: String?,
    limit: Long,
    offset: Long,
  ): Query<SeriesEntity> = pageFiltered(group, query, limit, offset) { id, sourceId, seriesId, name,
      posterUrl, plot, castMembers, director, genre, releaseDate, rating, groupName ->
    SeriesEntity(
      id,
      sourceId,
      seriesId,
      name,
      posterUrl,
      plot,
      castMembers,
      director,
      genre,
      releaseDate,
      rating,
      groupName
    )
  }

  public fun countFiltered(group: String?, query: String?): Query<Long> = CountFilteredQuery(group,
      query) { cursor ->
    cursor.getLong(0)!!
  }

  public fun <T : Any> selectByKey(
    sourceId: String,
    seriesId: Long,
    mapper: (
      id: String,
      sourceId: String,
      seriesId: Long,
      name: String,
      posterUrl: String?,
      plot: String?,
      castMembers: String?,
      director: String?,
      genre: String?,
      releaseDate: String?,
      rating: Double?,
      groupName: String?,
    ) -> T,
  ): Query<T> = SelectByKeyQuery(sourceId, seriesId) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getLong(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getString(7),
      cursor.getString(8),
      cursor.getString(9),
      cursor.getDouble(10),
      cursor.getString(11)
    )
  }

  public fun selectByKey(sourceId: String, seriesId: Long): Query<SeriesEntity> =
      selectByKey(sourceId, seriesId) { id, sourceId_, seriesId_, name, posterUrl, plot,
      castMembers, director, genre, releaseDate, rating, groupName ->
    SeriesEntity(
      id,
      sourceId_,
      seriesId_,
      name,
      posterUrl,
      plot,
      castMembers,
      director,
      genre,
      releaseDate,
      rating,
      groupName
    )
  }

  public fun insert(
    id: String,
    sourceId: String,
    seriesId: Long,
    name: String,
    posterUrl: String?,
    plot: String?,
    castMembers: String?,
    director: String?,
    genre: String?,
    releaseDate: String?,
    rating: Double?,
    groupName: String?,
  ) {
    driver.execute(113_702_120, """
        |INSERT OR REPLACE INTO SeriesEntity(id, sourceId, seriesId, name, posterUrl, plot, castMembers, director, genre, releaseDate, rating, groupName)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 12) {
          bindString(0, id)
          bindString(1, sourceId)
          bindLong(2, seriesId)
          bindString(3, name)
          bindString(4, posterUrl)
          bindString(5, plot)
          bindString(6, castMembers)
          bindString(7, director)
          bindString(8, genre)
          bindString(9, releaseDate)
          bindDouble(10, rating)
          bindString(11, groupName)
        }
    notifyQueries(113_702_120) { emit ->
      emit("SeriesEntity")
    }
  }

  public fun deleteBySourceId(sourceId: String) {
    driver.execute(-998_438_009, """DELETE FROM SeriesEntity WHERE sourceId = ?""", 1) {
          bindString(0, sourceId)
        }
    notifyQueries(-998_438_009) { emit ->
      emit("SeriesEntity")
    }
  }

  public fun deleteAll() {
    driver.execute(-1_403_518_105, """DELETE FROM SeriesEntity""", 0)
    notifyQueries(-1_403_518_105) { emit ->
      emit("SeriesEntity")
    }
  }

  private inner class PageFilteredQuery<out T : Any>(
    public val group: String?,
    public val query: String?,
    public val limit: Long,
    public val offset: Long,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("SeriesEntity", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("SeriesEntity", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null, """
    |SELECT SeriesEntity.id, SeriesEntity.sourceId, SeriesEntity.seriesId, SeriesEntity.name, SeriesEntity.posterUrl, SeriesEntity.plot, SeriesEntity.castMembers, SeriesEntity.director, SeriesEntity.genre, SeriesEntity.releaseDate, SeriesEntity.rating, SeriesEntity.groupName FROM SeriesEntity
    |WHERE (? IS NULL OR groupName ${ if (group == null) "IS" else "=" } ?)
    |  AND (? IS NULL OR name LIKE '%' || ? || '%')
    |ORDER BY name
    |LIMIT ? OFFSET ?
    """.trimMargin(), mapper, 6) {
      bindString(0, group)
      bindString(1, group)
      bindString(2, query)
      bindString(3, query)
      bindLong(4, limit)
      bindLong(5, offset)
    }

    override fun toString(): String = "Series.sq:pageFiltered"
  }

  private inner class CountFilteredQuery<out T : Any>(
    public val group: String?,
    public val query: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("SeriesEntity", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("SeriesEntity", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null, """
    |SELECT COUNT(*) FROM SeriesEntity
    |WHERE (? IS NULL OR groupName ${ if (group == null) "IS" else "=" } ?)
    |  AND (? IS NULL OR name LIKE '%' || ? || '%')
    """.trimMargin(), mapper, 4) {
      bindString(0, group)
      bindString(1, group)
      bindString(2, query)
      bindString(3, query)
    }

    override fun toString(): String = "Series.sq:countFiltered"
  }

  private inner class SelectByKeyQuery<out T : Any>(
    public val sourceId: String,
    public val seriesId: Long,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("SeriesEntity", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("SeriesEntity", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_177_391_645,
        """SELECT SeriesEntity.id, SeriesEntity.sourceId, SeriesEntity.seriesId, SeriesEntity.name, SeriesEntity.posterUrl, SeriesEntity.plot, SeriesEntity.castMembers, SeriesEntity.director, SeriesEntity.genre, SeriesEntity.releaseDate, SeriesEntity.rating, SeriesEntity.groupName FROM SeriesEntity WHERE sourceId = ? AND seriesId = ? LIMIT 1""",
        mapper, 2) {
      bindString(0, sourceId)
      bindLong(1, seriesId)
    }

    override fun toString(): String = "Series.sq:selectByKey"
  }
}
